import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function CardGeneral({ animal }) {
    const { t } = useTranslation()

    return (
        <>
            <Row className="mb-3">
                <Col xs={12} md={4}><strong>{t('card.ID')}:</strong> {animal.identifier}</Col>
                <Col xs={12} md={4}><strong>{t('card.lot')}:</strong> {animal?.lot?.identifier}</Col>
                <Col xs={12} md={4}><strong>{t('card.zone')}:</strong> {animal?.lot?.zone?.name}</Col>
            </Row>
        </>
    )
}
